export const NO_DISPLAY_ASSETS_TEXT = 'There is no display assets!';
export const NO_VIDEO_ASSETS_TEXT = 'There is no video assets!';
export const NO_TEXT_ASSETS_TEXT = 'There is no text assets!';
